module.exports = __webpack_public_path__ + "img/logo.5d5ebfd5.png";